export const FORM_ERRORS_IDS = Object.freeze({
  adminJobDetails: 'adminJobDetails',
  adminPropertiesForm: 'adminPropertiesForm',
  adminUserForm: 'adminUserForm',
  remoteOrder: 'remoteOrder',
  formTest: 'formTest',
});
